/* eslint-disable no-console */
/* eslint-disable max-len */
// 将字符串转换为TokenList
import {
    isString, map, includes, merge,
} from 'lodash';
import {
    LOGIC_OPERATOR_AND,
    LOGIC_OPERATOR_OR,
    LOGIC_OPERATOR_NOT,
    LOGIC_OPERATOR_GAND,
    OPERATORS,
    TOKEN_TYPE_FIELD,
    TOKEN_TYPE_LOGIC,
    TOKEN_TYPE_OPERATOR,
    TOKEN_TYPE_PLACESYMBOL,
    TOKEN_TYPE_FREQUENCY,
    TOKEN_TYPE_SPACE,
    TOKEN_TYPE_USER,
    TOKEN_TYPE_QUERYSYMBOL,
    TOKEN_TYPE_TREE,
    TOKEN_TYPE_SPECIALQUERY,
    TOKEN_TYPE_SPECIAL_SYMBOL,
    TOKEN_TYPE_SEN_PARA,
    TOKEN_TYPE_WORKSPACE,
    HOVER_LIGHT_CHARACTER,
    HOVER_LIGHT_CLASS,
} from '../../constants';

/**
 * Token拆分规则:
 * 特殊字符 [\]
 * 特殊query : \[(SEMANTIC|BULK|BIO|CHEM|PHARM|SYNAPSE|CAS|CAS_MARKUSH)\][a-zA-Z0-9-]*
 * 公司树标识: TREE@
 * 操作符: [\(\)\[\]\:\=]
 * 非空格: \s+
 * 引号块: (\"[^"]*\"?)
 * 剩余所有字符: [^\s\(\)\[\]\:\'\"\=]+
 * */
// eslint-disable-next-line no-useless-escape
const REG_TOKEN = /[\\]|\[(SEMANTIC|BULK|BIO|CHEM|PHARM|SYNAPSE|CAS|CAS_MARKUSH)\][a-zA-Z0-9-]*|TREE@|[\(\)\[\]\:\=\（\）\：]|\s+|(\'[^']*\'?)|(\"[^"]*\"?)|(\|[^|]*\|?)|[^\s\(\)\[\]\:\'\"\=\\\（\）\：]+/ig;

const LOGIC_OPERATORS = [LOGIC_OPERATOR_AND, LOGIC_OPERATOR_OR, LOGIC_OPERATOR_NOT, LOGIC_OPERATOR_GAND];

const repairText = (text) => text
    .replace(/[\t\r\n]/g, ' ');

const repairChineseOperators = (text) => text
    .replace(/（/g, '(')
    .replace(/）/g, ')')
    .replace(/：/g, ':');

const splitWords = (text) => text.match(REG_TOKEN);

function getExteralClass(token) {
    let exteralClass = '';
    if (includes(HOVER_LIGHT_CHARACTER, token)) {
        exteralClass = HOVER_LIGHT_CLASS;
    }
    return exteralClass;
}
export default class Token {
    constructor(isRDVersion = false) {
        this.token = [];
        this.TokenList = [];
        this.config = {};
        this.isRDVersion = isRDVersion;
    }

    getTokenList(text, config) {
        if (!isString(text)) return [];
        this.config = merge({}, config);
        this.text = text;
        this.originText = repairText(text);
        this.token = splitWords(this.originText);
        this.TokenList = this.formatTokenList(this.token);
        if (localStorage.getItem('debugger')) {
            console.log('==splitWords==\n', this.token);
            console.log('==TokenList==\n', this.TokenList);
        }
        return this.TokenList;
    }

    formatTokenList(token) {
        let startPos = 0;
        return map(token, (item, index) => {
            const data = this.getTokenData({ token: item, index, startPos });
            startPos += item.length;
            return data;
        });
    }

    getTokenData({ token, index, startPos }) {
        const data = {
            id: `000${index}`,
            value: token,
            start: startPos,
            end: startPos + token.length,
            type: TOKEN_TYPE_USER,
            exteralClass: '',
        };
        data.type = this.getTokenType({ token, index });
        data.exteralClass = getExteralClass(token);
        if (data.type === TOKEN_TYPE_OPERATOR) {
            data.value = repairChineseOperators(data.value);
        }
        return data;
    }

    getTokenType({ token, index }) {
        /**
         * RD版本无位置符和频率符
         */
        let type = TOKEN_TYPE_USER;
        if (includes(LOGIC_OPERATORS, token.toLocaleUpperCase())) {
            type = TOKEN_TYPE_LOGIC;
        } else if (includes(OPERATORS, token)) {
            type = TOKEN_TYPE_OPERATOR;
        } else if (/^\s+$/.test(token)) {
            type = TOKEN_TYPE_SPACE;
        } else if (!this.isRDVersion && /^\$(W|PRE)/.test(token.toUpperCase())) {
            type = TOKEN_TYPE_PLACESYMBOL;
        } else if (!this.isRDVersion && /^\$(FREQ)/.test(token.toUpperCase())) {
            type = TOKEN_TYPE_FREQUENCY;
        } else if (!this.isRDVersion && /^\$(SEN|PARA)/.test(token.toUpperCase())) {
            type = TOKEN_TYPE_SEN_PARA;
        } else if (this.config.symbolList && includes(this.config.symbolList, token.toUpperCase())) {
            type = TOKEN_TYPE_QUERYSYMBOL;
        } else if (/^TREE@/.test(token.toUpperCase())) {
            type = TOKEN_TYPE_TREE;
        } else if (/^\[(SEMANTIC|BULK|BIO|CHEM|PHARM|SYNAPSE|CAS|CAS_MARKUSH)\][a-zA-Z0-9-]*$/.test(token.toUpperCase())) {
            type = TOKEN_TYPE_SPECIALQUERY;
        // } else if (/[\\]/.test(token) && !/(\|[^|]*\|?)/.test(token)) {
        } else if (/(\|[^|]*\|?)/.test(token)) {
            type = TOKEN_TYPE_WORKSPACE;
        } else if (/[\\]/.test(token)) {
            type = TOKEN_TYPE_SPECIAL_SYMBOL;
        } else if (this.token[index + 1] === ':' || (/\s+/.test(this.token[index + 1]) && this.token[index + 2] === ':')) {
            type = TOKEN_TYPE_FIELD;
        }
        return type;
    }
}
